import * as v from "@badrap/valita";

import { $NonNegativeInteger } from "./misc.ts";
import { $ProductId } from "./product.ts";

export type Menu = Array<v.Infer<typeof $ProductId> | Folder>;

export const $Menu: v.Type<Menu> = v.lazy(() =>
  v.array(v.union($ProductId, $Folder)),
);

export type Folder = {
  id: string;
  name: string;
  background: number;
  children: Menu;
};

export const $Folder = v.object({
  id: v.string(),
  name: v.string(),
  background: $NonNegativeInteger,
  children: $Menu,
});
